import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="simulation-conversion-preview"
export default class extends Controller {
  static targets = ["resultingWeight"];

  connect() {
    this.resultingWeightTargets.forEach((target) =>
      this.renderResultingWeight(target),
    );
  }

  recalculate(event) {
    const row = event.currentTarget.closest(
      "[data-simulation-conversion-preview-target='harvestRow']",
    );
    if (!row) return;

    if (event.currentTarget.matches("select[name$='[harvest_unit_id]']")) {
      this.updateUnitCountFromSimulatedKg(row);
    }

    const target = row.querySelector(
      "[data-simulation-conversion-preview-target='resultingWeight']",
    );
    if (target) this.renderResultingWeight(target);
  }

  renderResultingWeight(target) {
    const row = target.closest(
      "[data-simulation-conversion-preview-target='harvestRow']",
    );
    if (!row) return;

    const resultingKg = this.resultingKg(row);

    if (!Number.isFinite(resultingKg) || resultingKg <= 0) {
      target.textContent = "-";
      row.dataset.allocationKg = "";
      return;
    }

    row.dataset.allocationKg = String(resultingKg);
    target.textContent = this.formatWeight(resultingKg, "kg");
  }

  updateUnitCountFromSimulatedKg(row) {
    const simulatedKg = this.simulatedKg(row);
    const capacityValue = this.selectedCapacityValue(row);
    const unitCountInput = row.querySelector(
      "input[name$='[total_harvest_units]']",
    );

    if (
      !Number.isFinite(simulatedKg) ||
      !Number.isFinite(capacityValue) ||
      capacityValue === 0 ||
      !unitCountInput
    ) {
      return;
    }

    unitCountInput.value = String(Math.round(simulatedKg / capacityValue));
  }

  resultingKg(row) {
    const capacityValue = this.selectedCapacityValue(row);
    const units = this.unitCount(row);

    if (
      !Number.isFinite(capacityValue) ||
      capacityValue === 0 ||
      !Number.isFinite(units) ||
      units <= 0
    ) {
      return NaN;
    }

    return units * capacityValue;
  }

  unitCount(row) {
    const unitCountInput = row.querySelector(
      "input[name$='[total_harvest_units]']",
    );
    if (!unitCountInput) return NaN;

    return Number.parseFloat(unitCountInput.value);
  }

  simulatedKg(row) {
    return Number.parseFloat(row.dataset.simulatedKg || "");
  }

  selectedCapacityValue(row) {
    const unitSelect = row.querySelector("select[name$='[harvest_unit_id]']");
    const option = this.selectedOption(unitSelect);

    return Number.parseFloat(option?.dataset.capacityValue || "");
  }

  formatWeight(value, unit) {
    return `${this.formatNumber(value)} ${unit}`;
  }

  selectedOption(select) {
    if (!select) return null;

    return (
      Array.from(select.options).find(
        (option) => option.value === select.value,
      ) ||
      select.querySelector("option[selected]") ||
      select.options[0]
    );
  }

  formatNumber(value) {
    return new Intl.NumberFormat(this.locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(value);
  }

  get locale() {
    return document.documentElement.lang || navigator.language || "en";
  }
}
